import React from 'react';
import { startSetContracts, startAddContract, startApproveContract } from '../../../../actions/contracts';

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import { map, size, flatten } from 'lodash';
import { FMessage, iFMessage } from '../../../../hoc/IntlComponents';
import ContractsOpeningWords from '../../../../components/Contracts/ContractsOpeningWords';
import ContractsForm from './ContractsForm';
import WithAlert from '../../../../hoc/WithAlert';
import AddedContracts from '../../../../components/Contracts/AddedContracts';

const types = ['ip', 'ooo'];

class Contracts extends React.Component {

    state = {
        type: 0,
        loading: false,
        errors: {},
        error: false,
    };

    componentDidMount() {
        this.getContracts();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            showAlert,
            startApproveContract,
            intl,
        } = this.props;
        const prevLength = size(this.props.contracts['ip']) + size(this.props.contracts['ooo'])
        const nextLength = size(nextProps.contracts['ip']) + size(nextProps.contracts['ooo'])
        if (nextLength - prevLength === 1) {
            const prevContractsIds = flatten(Object.keys(this.props.contracts).map(key => {
                return map(this.props.contracts[key], el => `${key}_${el.id}`)
            }));
            const nextContractsIds = flatten(Object.keys(nextProps.contracts).map(key => {
                return map(nextProps.contracts[key], el => `${key}_${el.id}`)
            }));
            let newId = null;
            nextContractsIds.forEach(id => {
                if (!prevContractsIds.includes(id)) {
                    newId = id;
                }
            });
            if (newId) {
                const [type, itemId] = newId.split('_');
                const element = nextProps.contracts[type][itemId];
                startApproveContract(type, element).then(() => {
                    showAlert({
                        alertType: 'success',
                        message: iFMessage({ intl, id: 'contracts.alert.approve.success' }),
                        dismissable: true,
                    });
                });
            }
        }
    }

    getContractsCount = () => {
        const { contracts } = this.props;
        let count = 0;
        types.forEach(type => count += Object.keys(contracts[type]).length);
        return count;
    };

    getContracts = () => {
        const { showAlert, startSetContracts } = this.props;
        this.setState({
            loading: true,
            error: false,
        });
        const reqArray = types.map((value, index) => startSetContracts(index));
        axios.all(reqArray)
            .catch(({ response }) => {
                if (response && response.data && response.data.error) {
                    const { message: error } = response.data.error;
                    showAlert({
                        alertType: 'danger',
                        message: error.message,
                        dismissable: true,
                    });
                    this.setState({ error: true });
                }
            })
            .finally(() => this.setState({ loading: false }));
    }

    onSubmit = item => {
        const { startAddContract, showAlert, intl } = this.props;
        const { type } = this.state;
        this.setState({ loading: true })
        startAddContract(type, item)
            .then(() => {
                showAlert({
                    alertType: 'success',
                    message: iFMessage({ intl, id: 'contracts.alert.add.success' }),
                    dismissable: true,
                });
            })
            .finally(() => {
                this.setState({ loading: false })
            });
    };

    handleTypeChange = type => {
        this.setState(() => ({ type }));
    };


    render() {
        const { contracts, showAlert } = this.props;
        const { loading, type, error } = this.state;
        return (
            <div>
                {/* <ContractsOpeningWords /> */}
                <ContractsForm
                    type={type}
                    types={types}
                    onSubmit={this.onSubmit}
                    contracts={contracts}
                    disabled={error}
                    handleTypeChange={this.handleTypeChange}
                    inModal={false}
                    loading={loading}
                />

                {
                    this.getContractsCount() ?
                        <AddedContracts
                            contracts={contracts}
                            types={types}
                            typeIndex={type}
                            error={error}
                            showAlert={showAlert}
                        />
                        :
                        null
                }
            </div>
        )
    }
}


const mapStateToProps = ({ contracts }) => ({ contracts });

const mapDispatchToProps = dispatch => ({
    startSetContracts: type => dispatch(startSetContracts(types[type])),
    startAddContract: (type, item) => dispatch(startAddContract(types[type], item)),
    startApproveContract: (contractType, item) => dispatch(startApproveContract(contractType, item)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WithAlert(injectIntl(Contracts)));